module.exports = __webpack_public_path__ + "static/gold-reflections-afbd518190cc33f93c9bf9028a1235ca.jpg";